import type { ComponentProps } from 'react'

import { cn } from '../../lib/utils'

const Card = ({ className, ref, ...props }: ComponentProps<'div'>) => (
  <div ref={ref} className={cn('bg-card text-card-foreground rounded-xl border shadow', className)} {...props} />
)
Card.displayName = 'Card'

const CardHeader = ({ className, ref, ...props }: ComponentProps<'div'>) => (
  <div ref={ref} className={cn('flex flex-col space-y-1.5 p-4 md:p-6', className)} {...props} />
)
CardHeader.displayName = 'CardHeader'

const CardTitle = ({ className, ref, ...props }: ComponentProps<'h3'>) => (
  <h3 ref={ref} className={cn('text-center text-lg leading-none font-semibold tracking-tight', className)} {...props} />
)
CardTitle.displayName = 'CardTitle'

const CardDescription = ({ className, ref, ...props }: ComponentProps<'p'>) => (
  <p ref={ref} className={cn('text-muted-foreground text-sm', className)} {...props} />
)
CardDescription.displayName = 'CardDescription'

const CardContent = ({ className, ref, ...props }: ComponentProps<'div'>) => (
  <div ref={ref} className={cn('p-4 pt-0 md:p-6', className)} {...props} />
)
CardContent.displayName = 'CardContent'

const CardFooter = ({ className, ref, ...props }: ComponentProps<'div'>) => (
  <div ref={ref} className={cn('flex items-center p-4 pt-0 md:p-6', className)} {...props} />
)
CardFooter.displayName = 'CardFooter'

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent }
